import { Router } from '@angular/router';
import { WalletService } from './../../Wallet/wallet.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ProfileService } from 'src/app/profile/profile.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-transfer-funds-internally',
  templateUrl: './transfer-funds-internally.component.html',
  styleUrls: ['./transfer-funds-internally.component.css']
})
export class TransferFundsInternallyComponent implements OnInit {
  @ViewChild('transferModal') modal!: ElementRef;
  senderAccountID = localStorage.getItem("accountID");
  userData: any;
  labelFlag: boolean = false;
  errorMes: any;
  msg = '';

  constructor(private userProfile: ProfileService, private walletService: WalletService, private route: Router) { }

  ngOnInit(): void {
  }

  transferData = new FormGroup({
    receiverAccountNumber: new FormControl("", Validators.required),
    amount: new FormControl("", [Validators.required])

  })

  getRecieverName(d: any){
      let payload = d.value;
        this.userProfile.getUserDetails(payload).subscribe((res:any) => {
          if(res.status==200){
            this.labelFlag = true;
            this.userData = res.result[0]
          } else if(res.status == 204){
            this.labelFlag = false;
            this.errorMes = res?.message;
          }
          
        })
  }

  public clearForm(){
    this.transferData.reset();
    this.userData = '';
  }

  send(){
    const data =  this.transferData.getRawValue();
    data.senderAccountNumber = this.senderAccountID
    this.walletService.transferInternal(data).subscribe((res:any) =>{
      if(res.status ==200){
        this.msg = res.message;
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title:'Transaction Successful',
          showConfirmButton: false,
          timer: 3500
        })
        this.clearForm();
      } else {
        this.msg = res.message;
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title:'Transaction Failed',
          showConfirmButton: false,
          timer: 3500
        })
        this.clearForm();
      }
    })
    this.reloadComponent();

  }

  reloadComponent() {
    this.route.navigateByUrl('/myboard/wallet', { skipLocationChange: true }).then(() => {
      this.route.navigate(['/myboard/wallet']);
    });
  }

  closeModal(){
    this.modal.nativeElement.classList.remove('show');
    document.body.classList.remove('modal-open');
    document.body.style.paddingRight = '';
    console.log("Fund wallet closed");
    
  }

}
